import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { createIncomingQuoteLineItem } from "MODULES/IncomingQuotes/actions";
import {
  AS_IS,
  INCOMING_LINE_ITEMS,
  NOT_AWAITING_REPLY,
  STANDARD
} from "MODULES/IncomingQuotes/constants";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import { QUOTE_TYPE } from "MODULES/OutgoingQuotes/constants";
import { LEAD_TIME } from "MODULES/inventories/constants";
import Form from "./Form";

const {
  [NOT_AWAITING_REPLY]: _,
  [AS_IS]: __,
  ...quoteTypes
} = INCOMING_LINE_ITEMS.quoteType;

const CreatePart = props => {
  const { close, incomingQuote, onSubmit, open } = props;
  const initialValues = {
    quote_type:
      incomingQuote.getIn(["incoming_quote_line_items", 0, QUOTE_TYPE]) ||
      STANDARD,
    lead_time: incomingQuote.getIn(["incoming_quote_line_items", 0, LEAD_TIME])
  };

  return (
    <Modal open={open} close={close} dialogClass="modal-lg">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Add a Part</h4>
      </Header>
      <Form
        close={close}
        initialValues={initialValues}
        onSubmit={onSubmit}
        quoteTypes={quoteTypes}
      />
    </Modal>
  );
};

export default connect(undefined, dispatch => ({
  onSubmit: data => dispatch(createIncomingQuoteLineItem(data))
}))(CreatePart);

CreatePart.propTypes = {
  close: PropTypes.func.isRequired,
  incomingQuote: PropTypes.instanceOf(Map),
  onSubmit: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/IncomingQuotes/Parts/CreatePart.jsx